import {Card, theme} from 'antd';
import DialogView from 'Components/DialogView';
import SectionCardTitle from 'Components/SectionCardTitle';
import React, {useState, useEffect, useRef} from 'react';
import SRFormSelector from '../../SRForms/SRFormSelector';
import ServiceRequestSummarySR from '../ServiceRequestSummary';
import {useSelector} from 'react-redux';
import {gqlOwnerDetails} from 'GQL/MethodsBFF/ServiceRequest';
import Payment from '../Payment';
import Activities from '../Activities';

interface IProps {
  openSRDetailViewDialogDialog: boolean;
  isOenSRDetailViewDialogDialog: any;
  claimId?: any;
}

const SRDetailViewDialog: React.FC<IProps> = (props) => {
  const {openSRDetailViewDialogDialog, isOenSRDetailViewDialogDialog, claimId} = props;
  const accessToken = useSelector((state: any) => state?.login.loginInfo?.access_token);
  const serviceToken = useSelector((state: any) => state?.login.loginInfo?.service_token);
  const loginDetails = useSelector((state: any) => state?.login);
  const selectedSRId = useSelector((state: any) => state.selectedSR?.getServiceRequestById?.id);

  const [srType, setSRType] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [srSubType, setSRSubTypes]: any = useState([]);
  const [srOwnerList, setOwnerList] = useState([]);
  const [isSubTypeMandatory, setIsSubTypeMandatory] = useState(false);
  const summaryRef = useRef<any>();
  const typeDetailsRef = useRef<any>();
  const activityRef = useRef<any>();
  const paymentRef = useRef<any>();
  const {token}: any = theme.useToken();

  useEffect(() => {
    (async () => {
      try {
        let headers = {
          'tenant-id': loginDetails?.tenantID, //'internal',
          'user-access-token': accessToken,
          'client-access-token': serviceToken,
        };
        let response = await gqlOwnerDetails(headers);
        if (response.error) {
          setOwnerList([]);
        } else {
          setOwnerList(response);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [srType]);

  const scrollTo = (ref: React.MutableRefObject<any>) => () => {
    if (!ref.current) return;
    ref.current.scrollIntoView({behavior: 'smooth', block: 'start'});
  };

  // `.modal-section-nav` pattern from the mockup's `#modal-sr-detail`: small
  // rounded pill buttons that scroll-jump to each section below, rather than
  // the previous two plain primary buttons (which only covered Payment/Activity).
  const sections = [
    {label: 'Summary', ref: summaryRef},
    {label: 'Type & details', ref: typeDetailsRef},
    {label: 'Payment', ref: paymentRef},
    {label: 'Activities', ref: activityRef},
  ];

  return (
    <DialogView
      // Was always "New service request", even when opening an existing SR.
      title={selectedSRId ? `Service request #${selectedSRId}` : 'New service request'}
      closeDialogMethod={isOenSRDetailViewDialogDialog}
      open={openSRDetailViewDialogDialog}>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <div
          style={{
            display: 'flex',
            gap: 6,
            flexWrap: 'wrap',
            padding: '0 24px 12px',
            marginTop: 18,
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
          }}>
          {sections.map((section) => (
            <button
              key={section.label}
              type="button"
              onClick={scrollTo(section.ref)}
              style={{
                background: token.colorFillAlter,
                border: 'none',
                borderRadius: token.borderRadiusLG,
                padding: '5px 12px',
                fontSize: 12,
                fontWeight: 600,
                color: token.colorTextSecondary,
                cursor: 'pointer',
              }}>
              {section.label}
            </button>
          ))}
        </div>
        <div ref={summaryRef} style={{padding: '0 24px'}}>
          <Card style={{marginTop: 16}}>
            <SectionCardTitle>Summary</SectionCardTitle>
            <ServiceRequestSummarySR
              srDetails={{
                srType,
                serviceType,
                srSubType,
                srOwnerList: srOwnerList,
                isSubTypeMandatory,
              }}
              srType={srType}
              serviceType={serviceType}
              setSRType={setSRType}
              setServiceType={setServiceType}
              setSRSubType={setSRSubTypes}
              setIsSubTypeMandatory={setIsSubTypeMandatory}
              claimId={claimId}
            />
          </Card>
        </div>
        <div ref={typeDetailsRef} style={{padding: '0 24px'}}>
          <Card style={{marginTop: 16}}>
            <SectionCardTitle>Type &amp; details</SectionCardTitle>
            <SRFormSelector
              srDetails={{
                srType,
                serviceType,
                srSubType,
                srOwnerList: srOwnerList,
                isSubTypeMandatory,
                claimId,
              }}
              closeDialogMethod={isOenSRDetailViewDialogDialog}
            />
          </Card>
        </div>
        <Payment ref={paymentRef} />
        <Activities ref={activityRef} />
      </div>
    </DialogView>
  );
};

export default SRDetailViewDialog;
